import cookies from 'js-cookie'
import { useCallback, useState } from 'react'
import { appDomain } from '../../../../config'

const COOKIE_NAME = 'slite-discarded-orgs'

export function saveDiscardedOrgIdsToCookie(orgIds: string[]) {
  cookies.set(COOKIE_NAME, JSON.stringify(orgIds), {
    path: '/',
    domain: `.${appDomain}`,
    sameSite: 'Lax',
    expires: 365, // 1 year
  })
}

export function getDiscardedOrgIdsFromCookie() {
  const orgIdsString = cookies.get(COOKIE_NAME)
  if (!orgIdsString) {
    return []
  }
  try {
    return JSON.parse(orgIdsString ?? '')
  } catch {
    return []
  }
}

export function useDiscardOrg() {
  const [discardedOrgIds, setDiscardedOrgIds] = useState(
    getDiscardedOrgIdsFromCookie()
  )
  const discardOrg = useCallback(
    (orgId: string) => {
      const newDiscardedOrgIds = [...discardedOrgIds, orgId]
      saveDiscardedOrgIdsToCookie(newDiscardedOrgIds)
      setDiscardedOrgIds(newDiscardedOrgIds)
    },
    [discardedOrgIds]
  )

  return {
    discardOrg,
    discardedOrgIds,
  }
}
